import { Meteor } from 'meteor/meteor'
import moment from 'moment'

import { queueControl } from './LoaderData'
import { dispatch } from './store'
import { CLOSE_ALERTDIALOG, OPEN_ALERTDIALOG } from './reducers/alertDialog'
import { OPEN_LOADER, CLOSE_LOADER } from './reducers/loader'

export const logout = () => {
  if (queueControl && queueControl.pause) queueControl.pause()

  window.history.pushState({ page: '/' }, '', '/')

  localStorage.removeItem(['Meteor.loginToken', 'Meteor.userId'])

  Meteor.logout()

  window.location.reload()
}
export const mailto = (mail) => {
  window.open(`mailto:${mail}`)
}

export const ucfirst = (children) => {
  return typeof children === 'string' && children.length > 0
    ? children[0].toUpperCase() + children.substring(1).toLowerCase()
    : children
}

export const weekArray = () => {
  const { lang = 'fr' } = JSON.parse(localStorage.getItem('callalawyer') || '{}') || {}
  moment.locale(lang)
  return moment.weekdays(true)
}

export const formatHour = (hourMinutes, format = ':') => {
  return `${hourMinutes.substr(0, 2)}${format}${hourMinutes.substr(2, 2)}`
}

export const sendToSlack = (channel, message) => {
  Meteor.promise('sendSlack', { channel, message })
    .then(() => {})
    .catch((error) => console.error(error))
}

export const openAlertDialog = async ({
  message = '',
  title = '',
}: {
  message: string,
  title: string,
}) => {
  dispatch({
    type: OPEN_ALERTDIALOG,
    payload: {
      message,
      title,
    },
  })
}

export const closeAlertDialog = async () => {
  dispatch({
    type: CLOSE_ALERTDIALOG,
  })
}

export const openLoader = async () => {
  dispatch({
    type: OPEN_LOADER,
  })
}

export const closeLoader = async () => {
  dispatch({
    type: CLOSE_LOADER,
  })
}

/**
 * This function return a boolean which determine if the user have a validated (aka fully completed) account or not
 * @returns {boolean}
 */
export const getProfileRegistar = () => {
  if (!Meteor.user()) return false

  const user = Meteor.user()
  const { profile } = user

  if (profile?.type === 'customer') return false

  if (profile?.type === 'lawyer')
    return !profile.validated || !profile.skills || profile.skills.length === 0

  /*
    //@todo  faire un import de getProfile Registar du serveur
  const { validated } = await Meteor.promise('getProfileRegistar')

  return !validated
   */

  return false
}

export const getTypeProfile = () => {
  if (!Meteor.user()) return false
  const { profile } = Meteor.user()

  if (!profile) return {}
  let typeProfile = profile.type

  if (
    profile.type === 'customer' &&
    profile.pro === true &&
    profile.parentId &&
    profile.parentId !== ''
  ) {
    typeProfile = 'proChildren'
  } else if (profile.type === 'customer' && profile.pro === true) {
    typeProfile = !!profile.subAccount && !!profile.offerId ? 'proCallIllimite' : 'pro'
  } else {
    typeProfile = profile.type
  }
  return { typeProfile, isAdmin: profile.admin, isSuperAdmin: profile.superAdmin }
}
